// MODULES
import React from "react";

// HELPERS
import {createClassName} from "@helpers/utils";
import fulfillmentCheck from "./InsuredKyc.fulfillment";
import DefaultFields from "../../../components/DefaultFields/DefaultFields";
import * as CobHelpers from "../../../Cob.helpers";
import OptionsList from "../../../components/OptionsList/OptionsList";
import EditableField from "../../../components/EditableField/EditableField";
import NumberField from "../../../components/NumberField/NumberField";
import {delay, getPropertiesByPrefix, parseDraftDataPropsToFieldState} from "../../../../../helpers/utils";


export default class InsuredKyc extends React.PureComponent {
	static companyExclusive = false;
	static privateExclusive = false;

	static fields = _getFields();
	state = _getInitialState.call(this);

	componentDidUpdate(prevProps, prevState) {
		const {props, state} = this;
		const {id, onChange} = props;

		if (prevState.fields !== state.fields) {
			onChange(id, {...state}, fulfillmentCheck(props, state));
		}

		if (prevProps.draftData !== props.draftData)
		{
			if (props.draftData)
			{
				// get the draftData props specific to this section only
				const draftDataProps = getPropertiesByPrefix(props.draftData, ["futur_insured_kyc_"]);
				// parse the draftData props into state.fields
				const newFieldsState = parseDraftDataPropsToFieldState(this.state.fields, draftDataProps);

				this.setState({fields: {...newFieldsState}},
					async () =>
					{
						await delay(200);
						onChange(id, {...this.state}, fulfillmentCheck(this.props, this.state));
					}
				);
			}
		}
	}

	render() {
		const {props, state} = this;
		const {title} = props;

		const classes = createClassName("Cob-Fees", {
			"Cob-View": true,
			"fulfilled": state.isFulfilled,
		});

		return (
			<div className={classes}>
				<DefaultFields fields={this.constructor.fields}/>

				<div className="Cob-Fields">
					<h2>{title}</h2>

					<OptionsList
						type="radio"
						orientation="vertical"
						name="futur_insured_kyc_meeting_form"
						options={state.fields.futur_insured_kyc_meeting_form.options}
						onChange={this._onOptionsListChange}
					/>

					<OptionsList
						type="radio"
						orientation="vertical"
						description={"Syftet med försäkringen"}
						name="futur_insured_kyc_purpose"
						options={state.fields.futur_insured_kyc_purpose.options}
						onChange={this._onOptionsListChange}
						style={{marginTop: "40px"}}
					/>

					{state.fields.futur_insured_kyc_purpose.options[3].checked && (
						<EditableField
							name="futur_insured_kyc_purpose_other"
							label="Ange"
							value={state.fields.futur_insured_kyc_purpose_other}
							valid={state.validFields.futur_insured_kyc_purpose_other}
							onChange={this._onFieldChange}
							onBlur={this._onFieldBlur}
							style={{marginTop: "10px", maxWidth: "300px"}}
						/>
					)}

					<OptionsList
						type="radio"
						orientation="vertical"
						description={"Vilken är den planerade insättningen i samband med tecknandet av försäkringen?"}
						name="futur_insured_kyc_initial_premium"
						options={state.fields.futur_insured_kyc_initial_premium.options}
						onChange={this._onOptionsListChange}
						style={{marginTop: "40px"}}
					/>

					{state.fields.futur_insured_kyc_initial_premium.options[5].checked && (
						<div style={{display: "block", width: "200px", marginTop: "10px"}}>
							<EditableField
								Component={NumberField}
								name="futur_insured_kyc_initial_premium_other"
								label="Ange estimat"
								value={state.fields.futur_insured_kyc_initial_premium_other}
								valid={state.validFields.futur_insured_kyc_initial_premium_other && state.fields.futur_insured_kyc_initial_premium_other > 10000000}
								onChange={this._onFieldChange}
								onBlur={this._onFieldBlur}
								unit={"kr"}
							/>
						</div>
					)}

					<OptionsList
						type="radio"
						orientation="vertical"
						description={"Vilken är den planerade insättningen per år?"}
						name="futur_insured_kyc_yearly_premium"
						options={state.fields.futur_insured_kyc_yearly_premium.options}
						onChange={this._onOptionsListChange}
						style={{marginTop: "40px"}}
					/>

					{state.fields.futur_insured_kyc_yearly_premium.options[6].checked && (
						<div style={{display: "block", width: "150px", marginTop: "10px"}}>
							<EditableField
								Component={NumberField}
								name="futur_insured_kyc_yearly_premium_other"
								label="Ange"
								value={state.fields.futur_insured_kyc_yearly_premium_other}
								valid={state.validFields.futur_insured_kyc_yearly_premium_other && state.fields.futur_insured_kyc_yearly_premium_other > 10000000}
								onChange={this._onFieldChange}
								onBlur={this._onFieldBlur}
								unit={"kr"}
								style={{maxWidth: "150px"}}
							/>
						</div>
					)}
				</div>
			</div>
		);
	}

	_fieldValidator = (name, value) => {
		return value.length > 0;
	};

	_onFieldChange = (name, value) => {
		CobHelpers.onViewFieldChange.call(this, name, value);
	};

	_onFieldBlur = (name) => {
		CobHelpers.onViewFieldBlur.call(this, name);
	};

	_onOptionsListChange = ({type, name}, option, index) => {
		const newOptions = [...this.state.fields[name].options].map((o, i) => {
			if (i === index) {
				return option;
			}
			else {
				return {...o, checked: type === "radio" ? false : o.checked};
			}
		});

		this.setState({
			fields: {
				...this.state.fields,
				[name]: {
					options: newOptions,
				},
			},
		}, () => fulfillmentCheck(this.props, this.state));
	};
}

function _getFields() {
	return [
		"futur_insured_kyc_meeting_form",

		"futur_insured_kyc_purpose",
		"futur_insured_kyc_purpose_other",

		"futur_insured_kyc_initial_premium",
		"futur_insured_kyc_initial_premium_other",

		"futur_insured_kyc_yearly_premium",
		"futur_insured_kyc_yearly_premium_other",
	];
}

function _getInitialState() {
	if (this.props.prevState) return {...this.props.prevState};

	return {
		validFields: {},
		fields: {
			futur_insured_kyc_meeting_form: {
				options: [
					{label: "Försäkring tecknad vid fysiskt möte med förmedlare/rådgivare", value: "PhysicalMeeting", checked: false},
					{label: "Försäkring tecknad på distans", value: "Distance", checked: false}
				]
			},

			futur_insured_kyc_purpose: {
				options: [
					{label: "Pensionssparande", value: "Pension", checked: false},
					{label: "Målsparande", value: "Objective", checked: false},
					{label: "Placering", value: "Investments", checked: false},
					{label: "Annat", value: "Other", checked: false},
				]
			},
			futur_insured_kyc_purpose_other: "",

			futur_insured_kyc_initial_premium: {
				options: [
					{label: "0 - 100 000 kr", value: "Amount0To100K", checked: false},
					{label: "100 001 - 500 000 kr", value: "Amount100KTo500K", checked: false},
					{label: "500 001 - 1 000 000 kr", value: "Amount500KTo1M", checked: false},
					{label: "1 000 001 - 5 000 000 kr", value: "Amount1MTo5M", checked: false},
					{label: "5 000 001 - 10 000 000 kr", value: "Amount5MTo10M", checked: false},
					{label: "över 10 000 000 kr", value: "AmountAbove10M", checked: false}
				]
			},
			futur_insured_kyc_initial_premium_other: "",

			futur_insured_kyc_yearly_premium: {
				options: [
					{label: "Endast engångsinsättning i samband med tecknandet av försäkringen", value: "NoYearlyPremium", checked: false},
					{label: "0 - 100 000 kr", value: "Amount0To100K", checked: false},
					{label: "100 001 - 500 000 kr", value: "Amount100KTo500K", checked: false},
					{label: "500 001 - 1 000 000 kr", value: "Amount500KTo1M", checked: false},
					{label: "1 000 001 - 5 000 000 kr", value: "Amount1MTo5M", checked: false},
					{label: "5 000 001 - 10 000 000 kr", value: "Amount5MTo10M", checked: false},
					{label: "över 10 000 000 kr", value: "AmountAbove10M", checked: false}
				]
			},
			futur_insured_kyc_yearly_premium_other: ""
		}
	};
}


// WEBPACK FOOTER //
// ./src/routes/Cob/views/Futur/InsuredKyc/InsuredKyc.js